/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { makeStyles } from '@material-ui/core/styles';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import * as planMessageData from '../../Plan/component/message';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  input: {
    color: 'red !important',
  },
}));
const MaintainGroupTabContainer = (props) => {
  const classes = useStyles();
  const { tabValue, handleChangeTabValue, errorMessages } = props;

  return (
    <>
      <div className={classes.root}>
        <AppBar
          position='static'
          sx={{ width: '100%' }}
          style={{ borderBottom: '1px solid #c9c8c5' }}
        >
          <Tabs
            value={tabValue}
            onChange={handleChangeTabValue}
            color='red'
            style={{ color: 'red' }}
          >
            <Tab
              style={{ textTransform: 'capitalize' }}
              value='one'
              label='Participation Dates'
              tabIndex={0}
            />
            {errorMessages &&
              errorMessages.length > 0 &&
              errorMessages.filter((x) => {
                return (
                  x.includes(
                    constantMessageData.PARTICIPATE_START_DATE_REWUIRED
                  ) ||
                  x.includes(constantMessageData.END_DATE_BEFORE_START_DATE) ||
                  x.includes(constantMessageData.START_END_DATE_OVERLAP) ||
                  x === planMessageData.PARTICIPATE_DATE_REQ
                );
              }).length > 0 && <span className='tab-error'>!</span>}
            <Tab
              style={{ textTransform: 'capitalize' }}
              value='two'
              label='Plans'
              tabIndex={0}
            />
            <Tab
              style={{ textTransform: 'capitalize' }}
              value='three'
              label='Contact'
              tabIndex={0}
            />
            {errorMessages &&
              errorMessages.length > 0 &&
              errorMessages.filter((x) => {
                return (
                  x === constantMessageData.NAME_REQUIRED ||
                  x === constantMessageData.CONTACT_TYPE_REQUIRED ||
                  x === constantMessageData.ADDRESS_LINE1_REQUIRED ||
                  x === constantMessageData.CITY_REQUIRED ||
                  x === constantMessageData.STATE_REQUIRED ||
                  x === constantMessageData.ZIP_REQUIRED ||
                  x === constantMessageData.ZIP4_REQUIRED ||
                  x === constantMessageData.PHONE_REQUIRED ||
                  x === constantMessageData.PHONE_INVALID_ERROR ||
                  x === constantMessageData.EMAIL_REQUIRED ||
                  x === constantMessageData.EMAIL_INVALID
                );
              }).length > 0 && <span className='tab-error'>!</span>}
          </Tabs>
        </AppBar>
      </div>
    </>
  );
};

export default MaintainGroupTabContainer;
